import { postJSON } from '../api'

export const subscribe = (token: string) =>
  postJSON({
    url: 'notifications/subscribe',
    json: { token }
  })

export const unsubscribe = (token: string) =>
  postJSON({
    url: 'notifications/unsubscribe',
    json: { token }
  })
